module.exports = __webpack_public_path__ + "static/media/web-design-desk.e5b20669.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/web-design-desk.jpeg
// module id = 275
// module chunks = 0